import { TFunction } from 'react-i18next';
import { HireFormTodoKey, OfferStageTodoKey, TodosConfig, TodoRowConfig, TodoItem } from './todoListTypes';

function checkValues<K extends HireFormTodoKey | OfferStageTodoKey>(
  todos: TodoItem<K>[] | undefined | null,
  key: K | undefined | null,
): boolean {
  if (!todos || !key || todos.length === 0) return true;

  return todos.find((todo) => todo.key === key)?.enabled ?? true;
}

export function buildCategoryItems<K extends HireFormTodoKey | OfferStageTodoKey>(
  category: keyof TodosConfig,
  i18nPrefix: string,
  rows: TodoRowConfig<K>[],
  todosForCategory: TodoItem<K>[] | undefined | null,
  t: TFunction<'accountParameter'>,
) {
  const sectionHeader = {
    key: `todos.${category}`,
    label: t(`todoPane.${i18nPrefix}.title`),
    description: '',
    value: '',
    type: 'boolean' as const,
    isSection: true,
  };

  const dataRows = rows.map(({ enumKey, i18nKey }) => ({
    key: `todos.${category}.${enumKey}`,
    label: t(`todoPane.${i18nPrefix}.${i18nKey}.title`),
    description: t(`todoPane.${i18nPrefix}.${i18nKey}.description`),
    value: checkValues(todosForCategory, enumKey),
    type: 'boolean' as const,
  }));

  return [sectionHeader, ...dataRows];
}
